module.exports = __webpack_public_path__ + "media/src/assets/Images/HSBC-99306f5e417f48fc4803d9a1cbadb4a1.svg";